"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashboardPermission = exports.getDashboardErrCode = exports.getDashboardLoading = exports.getDashboardClient = exports.getInstalledWidgetInDashboard = exports.getDashboardLayout = exports.getDashboardSnapshot = exports.getDashboard = exports.getDashboardPack = void 0;
const store_1 = require("../../../../../exports/store");
const getDashboardPack = (state, id) => {
    const dashboardId = state.pageParams.dashboardId || id;
    if (!dashboardId) {
        return;
    }
    const dashboardPack = state.dashboardMap[dashboardId];
    if (!dashboardPack) {
        return;
    }
    return dashboardPack;
};
exports.getDashboardPack = getDashboardPack;
const getDashboard = (state, id) => {
    const dashboardPack = (0, exports.getDashboardPack)(state, id);
    return dashboardPack === null || dashboardPack === void 0 ? void 0 : dashboardPack.dashboard;
};
exports.getDashboard = getDashboard;
const getDashboardSnapshot = (state, id) => {
    const dashboardPack = (0, exports.getDashboard)(state, id);
    return dashboardPack === null || dashboardPack === void 0 ? void 0 : dashboardPack.snapshot;
};
exports.getDashboardSnapshot = getDashboardSnapshot;
const getDashboardLayout = (state) => {
    const snapshot = (0, exports.getDashboardSnapshot)(state);
    return snapshot === null || snapshot === void 0 ? void 0 : snapshot.widgetInstallations.layout;
};
exports.getDashboardLayout = getDashboardLayout;
const getInstalledWidgetInDashboard = (state) => {
    const snapshot = (0, exports.getDashboardSnapshot)(state);
    const layout = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.widgetInstallations.layout) || [];
    return layout.map(v => v.id);
};
exports.getInstalledWidgetInDashboard = getInstalledWidgetInDashboard;
const getDashboardClient = (state) => {
    const dashboardPack = (0, exports.getDashboardPack)(state);
    return dashboardPack === null || dashboardPack === void 0 ? void 0 : dashboardPack.client;
};
exports.getDashboardClient = getDashboardClient;
const getDashboardLoading = (state) => {
    const dashboardPack = (0, exports.getDashboardPack)(state);
    return dashboardPack === null || dashboardPack === void 0 ? void 0 : dashboardPack.loading;
};
exports.getDashboardLoading = getDashboardLoading;
const getDashboardErrCode = (state) => {
    const dashboardPack = (0, exports.getDashboardPack)(state);
    return dashboardPack === null || dashboardPack === void 0 ? void 0 : dashboardPack.errorCode;
};
exports.getDashboardErrCode = getDashboardErrCode;
const getDashboardPermission = (state) => {
    const dashboardPack = (0, exports.getDashboardPack)(state);
    if (!dashboardPack || !dashboardPack.dashboard || !dashboardPack.connected) {
        return store_1.DEFAULT_PERMISSION;
    }
    return dashboardPack.dashboard.permissions;
};
exports.getDashboardPermission = getDashboardPermission;
//# sourceMappingURL=dashboard.js.map